import { Link, Outlet, createRootRouteWithContext, redirect } from '@tanstack/react-router';

import type { QueryClient } from '@tanstack/react-query';
import type { RouterAuthContext } from '@/utils/router-auth';
import { isSessionValid } from '@/utils/router-auth';
import { Toaster } from '@/components/ui/sonner.tsx';

interface MyRouterContext {
  queryClient: QueryClient;
  auth: RouterAuthContext;
}

function NotFoundComponent() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Page non trouvée</p>
        <Link to="/" className="text-primary underline hover:text-primary/80">
          {"Retour à l'accueil"}
        </Link>
      </div>
    </div>
  );
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  beforeLoad: ({ location }) => {
    const pathname = location.pathname;
    const isOnboardingRoute = pathname.startsWith('/onboarding');
    const isFeedbackRoute = pathname.startsWith('/feedback');
    const sessionValid = isSessionValid();

    // Route feedbacks publique : pas de redirection
    if (isFeedbackRoute) {
      return;
    }

    // Non authentifie et tente d'acceder a l'onboarding -> redirection vers login
    if (!sessionValid && isOnboardingRoute) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href
        }
      });
    }
  },
  component: () => (
    <>
      <Outlet />
      <Toaster />
    </>
  ),
  notFoundComponent: NotFoundComponent
});
